import React from 'react';
import PostDetailsLeftSide from '../../components/PostDetailsLeftSide/PostDetailsLeftSide';
import PostDetailsRightSide from '../../components/PostDetailsRightSide/PostDetailsRightSide';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEOHead from '../../components/SEO/SEOHead';
import { getBlogAlternates } from '../../utils/seoMappings';
import { shouldNoindexBlogPost } from '../../utils/seoIndexing';

const PostDetailsArea = ({ postData }) => {
   const navigate = useNavigate()
   const { i18n } = useTranslation();

   if (postData.length === 0) {
      navigate('/blogs')
   }

   const alternates = getBlogAlternates(postData[0]?.blogid, i18n.language);

   return (
      <>
         <section className="blog-area pt-50 pb-80">
            <SEOHead
               title={`${postData[0]?.title} | ${i18n.language === 'en' ? 'Assoc. Prof. Dr. Ebru Karagün' : 'Doç. Dr. Ebru Karagün'}`}
               description={postData[0]?.content?.metaDescription}
               image={postData[0]?.image}
               canonicalPath={i18n.language === 'en' ? `/en/blogs/${postData[0]?.blogid}` : `/blogs/${postData[0]?.blogid}`}
               trPath={alternates.trPath}
               enPath={alternates.enPath}
               noindex={shouldNoindexBlogPost(postData[0]?.blogid)}
            />
            <div className="container relative">
               <div className="header-info position-absolute d-md-none flex" style={{ top: 65 }}>
                  <a href="tel:+903125574646"> <span><i className="fas fa-phone"></i> +90 312 557 46 46</span></a>
                  <a href="tel:+905332691271"> <span><i className="fas fa-phone"></i> +90 533 269 12 71</span></a>
               </div>
               <div className="row">
                  <PostDetailsLeftSide postData={postData[0]} details_topBar={<div className="postbox__thumb mb-35">
                     <img src={postData[0]?.image} alt={postData[0]?.title} />
                  </div>} />

                  <PostDetailsRightSide />

               </div>
            </div>
         </section>
      </>
   );
};

export default PostDetailsArea;
